// extracted by mini-css-extract-plugin
export default {"ClientWelcomePage":"ClientWelcomePage_ClientWelcomePage__4Q25y","logo":"ClientWelcomePage_logo__JxkHv"};